<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 1024 523.626">
  <defs>
    <linearGradient id="linear-gradient" x1="0.517" y1="1" x2="0.522" y2="0.163" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="#fff"/>
      <stop offset="1" stop-color="#0f0f0f"/>
    </linearGradient>
  </defs>
  <g id="xiangmuliucheng4" transform="translate(0 -76.663)">
    <path id="路径_5004" data-name="路径 5004" d="M0,0H7.1V200.05H0Z" transform="translate(0 243.168)" fill="var(--theme-color-1)"/>
    <path id="路径_5005" data-name="路径 5005" d="M0,0H210.336V60H0Z" transform="translate(7.104 243.168)" fill="var(--theme-color-1)"/>
    <text id="_2021年12月" data-name="2021年12月" transform="translate(22 278.25)" fill="#fff" font-size="18" font-weight="600"><tspan x="0" y="0">2021年12月</tspan></text>
    <text id="执行方立项_确认项目细节" data-name="执行方立项,确认项目细节" transform="translate(37.439 343.168)" fill="var(--theme-color-1)" font-size="16" font-weight="500"><tspan x="0" y="0">执行方立项,确认项目细节</tspan></text>
    <text id="完成" transform="translate(37.439 408.217)" fill="var(--theme-color-1)" font-size="16" font-weight="500"><tspan x="0" y="0">完成</tspan></text>
    <circle id="椭圆_793" data-name="椭圆 793" cx="4.5" cy="4.5" r="4.5" transform="translate(22 332.168)" fill="var(--theme-color-1)"/>
    <circle id="椭圆_794" data-name="椭圆 794" cx="4.5" cy="4.5" r="4.5" transform="translate(22 398.168)" fill="var(--theme-color-1)"/>
    <g id="组_4861" data-name="组 4861" transform="translate(-6 -6.988)">
      <path id="路径_5006" data-name="路径 5006" d="M0,0H7.1V200.05H0Z" transform="translate(361 178.713)" fill="var(--theme-color-1)"/>
      <path id="路径_5007" data-name="路径 5007" d="M0,0H241.326V60H0Z" transform="translate(368.104 178.713)" fill="var(--theme-color-1)"/>
      <text id="_2021年12月-2023年12月" data-name="2021年12月-2023年12月" transform="translate(383 213.797)" fill="#fff" font-size="18" font-weight="600"><tspan x="0" y="0">2021年12月-2023年12月</tspan></text>
      <text id="项目全面推进" transform="translate(398.439 278.711)" fill="#272727" font-size="16" font-weight="500"><tspan x="0" y="0">项目全面推进</tspan></text>
      <text id="进行中" transform="translate(398.439 343.762)" fill="#272727" font-size="16" font-weight="500"><tspan x="0" y="0">进行中</tspan></text>
      <circle id="椭圆_795" data-name="椭圆 795" cx="4.5" cy="4.5" r="4.5" transform="translate(383 267.713)" fill="#0f0f0f"/>
      <circle id="椭圆_796" data-name="椭圆 796" cx="4.5" cy="4.5" r="4.5" transform="translate(383 333.713)" fill="#0f0f0f"/>
    </g>
    <path id="路径_5009" data-name="路径 5009" d="M0,0H7.1V200.05H0Z" transform="translate(714.561 76.663)" fill="var(--theme-color-1)"/>
    <path id="路径_5008" data-name="路径 5008" d="M0,0H302.336V60H0Z" transform="translate(721.664 76.663)" fill="var(--theme-color-1)"/>
    <text id="_2024年01月" data-name="2024年01月" transform="translate(736.561 111.749)" fill="#fff" font-size="18" font-weight="600"><tspan x="0" y="0">2024年01月</tspan></text>
    <text id="基于现有数据进行数据分析及项目结题" transform="translate(752 176.663)" fill="#272727" font-size="16" font-weight="500"><tspan x="0" y="0">基于现有数据进行数据分析及项目结题</tspan></text>
    <text id="待完成" transform="translate(752 241.714)" fill="#272727" font-size="16" font-weight="500"><tspan x="0" y="0">待完成</tspan></text>
    <circle id="椭圆_797" data-name="椭圆 797" cx="4.5" cy="4.5" r="4.5" transform="translate(736.561 165.663)" fill="#0f0f0f"/>
    <circle id="椭圆_798" data-name="椭圆 798" cx="4.5" cy="4.5" r="4.5" transform="translate(736.561 231.663)" fill="#0f0f0f"/>
    <path id="quxian" d="M15166.5-9481.545c-46.4,5.426-138.85,4.671-300.026,99.528s-242.02,89.734-358.908,89.857-365.065,80.98-365.065,80.98v99.186h1024Z" transform="translate(-14142.5 9712.282)" opacity="0.139" fill="url(#linear-gradient)"/>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped>
.svg-block {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
